import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { mostrarSubcategoriasEnMenu } from '../utils/subcategorias.util';

/**
 * Deja entrar a la pantalla de subcategorías solo si la empresa las usa (settings.subcategories.enabled) y tiene el
 * módulo de productos; si no, lleva a Productos (RF-41). Usa la misma regla que el ítem del menú.
 */
export const subcategoriasHabilitadasGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (mostrarSubcategoriasEnMenu(authService.businessSettings(), authService.hasFeature('products'))) {
    return true;
  }
  return router.createUrlTree(['/admin/inventory']);
};
